<template>
    <div class="consensus-rating" :class="[`consensus-rating--${ratingType}`]">
        <span class="consensus-rating__value">{{ rating }}</span>
        <span class="consensus-rating__label">{{ $t('consensus_rating') }}</span>
    </div>
</template>

<script >
import { computed } from 'vue-demi';
import { LanguageId, useI18n } from '../../common/useI18n';
const __sfc_main = {};
__sfc_main.props = {
  rating: {
    type: String,
    default: 'Buy' // Buy, Sell, Hold
  },
  languageId: {
    type: Number,
    default: LanguageId.EN
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 多语言
  const $t = useI18n(props.languageId);
  const ratingType = computed(() => {
    const r = props.rating.toLowerCase();
    if (r === 'buy' || r === 'strong buy' || r === '买入') return 'buy';
    if (r === 'sell' || r === 'strong sell' || r === '卖出') return 'sell';
    return 'hold';
  });
  return {
    $t,
    ratingType
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.consensus-rating {
    display: flex;
    flex-direction: column;
    gap: 0.04rem;

    &__value {
        font-size: 0.28rem;
        font-weight: 600;
        line-height: 1.4;
    }

    &__label {
        font-size: 0.22rem;
        color: #626262;
        line-height: 0.3rem;
        letter-spacing: -0.01rem;
        width: 1.2rem;
        height: 0.3rem;
    }

    // Buy - 绿色
    // &--buy {
    //     .consensus-rating__value {
    //         color: #52c41a;
    //     }
    // }

    // // Sell - 红色
    // &--sell {
    //     .consensus-rating__value {
    //         color: #ff4d4f;
    //     }
    // }

    // Hold - 灰色
    // &--hold {
    //     .consensus-rating__value {
    //         color: #999;
    //     }
    // }
}
</style>
